"use client"
import { Button } from "@/components/ui/button"
import { Plus } from "lucide-react"

interface AddCareerPathCardProps {
  onAdd?: () => void
}

export function AddCareerPathCard({ onAdd }: AddCareerPathCardProps) {
  return (
    <div
      onClick={onAdd}
      className="flex min-h-[300px] flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 transition hover:border-blue-600 hover:bg-blue-50 cursor-pointer"
    >
      <div className="flex flex-col items-center gap-4 p-6 text-center">
        {/* Plus Icon */}
        <div className="flex size-16 items-center justify-center rounded-full bg-blue-600/20 text-blue-600">
          <Plus className="w-8 h-8" />
        </div>

        {/* Heading */}
        <h3 className="text-lg font-bold text-slate-800">Ready for a New Adventure?</h3>

        {/* Add Button */}
        <Button
          onClick={(e) => { e.stopPropagation(); onAdd?.(); }}
          className="bg-slate-200 hover:bg-blue-600 text-slate-700 hover:text-white text-sm font-bold rounded-lg h-10 px-4 transition"
        >
          Add More Career Paths
        </Button>
      </div>
    </div>
  )
}